import {Route, type RouteMatch, type Router} from "../stem-core/ui/Router";
import {unwrapArray} from "../stem-core/base/Utils";
import {merchantService} from "./misc/MerchantService";

// For all pages without subroutes, just take in all their arguments
class PageRoute extends Route {
    // Left open: the page class comes from the route and takes its own options bag, which has nothing in
    // common with an element's - typing this as UIElement makes updateOptions below reject every page
    declare uiElement?: any;
    constructor(url: string | string[], uiClass: any, urlTitle: string) {
        super(url, uiClass, [], urlTitle);
    }

    matches(urlParts: string[]): RouteMatch | null {
        if (urlParts[0] != this.expr[0]) {
            return null;
        }
        return {
            args: urlParts.splice(1),
            urlParts: urlParts.splice(1),
        }
    }

    getPage(urlParts: string[], router?: Router, ...argsArray: (string | string[])[]) {
        const options = {
            args: unwrapArray(argsArray),
            baseURL: this.expr[0],
            merchant: merchantService.getMerchant(),
        };
        if (this.uiElement) {
            this.uiElement.updateOptions(options);
        } else {
            this.uiElement = new (this.pageGenerator as new (options: any) => any)(options);
        }
        return this.uiElement;
    }
}

export class Page {
    static titleSuffix = " - Blink Dashboard";

    // Set in the constructor, the rest through the Object.assign of `options` below
    declare url: string;
    declare name: string;
    declare uiClass: any;
    declare icon?: any;
    declare isMainSection?: boolean;

    declare ["constructor"]: typeof Page;

    constructor(url: string, name: string, uiClass: any, options?: Record<string, any>) {
        this.url = url;
        this.name = name;
        this.uiClass = uiClass;
        Object.assign(this, options);
        this.isMainSection = this.isMainSection ?? (this.icon != null);
    }

    toRoute(subRoutes: Route[] = []) {
        const urlTitle = this.name + this.constructor.titleSuffix;
        if (subRoutes) {
            return new Route(this.url, this.uiClass, subRoutes, urlTitle);
        }
        // We want to be terminal regardless of other arguments
        return new PageRoute(this.url, this.uiClass, urlTitle);
    }
}
